document.addEventListener('DOMContentLoaded', () => {
  var Customizer = Customizer || {};
  const isVisible = "is-visible";
  const initialButton = document.querySelector("[data-show-initial]");
  const initialClose = document.querySelector("[data-close-initial]");
  const initialWrapper = document.querySelector(".show-initial-wrapper");
  const initalRadioGroup = document.querySelectorAll("input[name='radio-group']");
  const openEls = document.querySelectorAll("[data-open]");
  const closeEls = document.querySelectorAll("[data-close]");
  const nextEls = document.querySelectorAll("button.next-step");
  const prevEls = document.querySelectorAll("button.previous-step");
  const colorOptions = document.querySelectorAll(".single-color");
  const sunglassesOptions = document.querySelectorAll(".option-item");
  const showPdAnswers = document.querySelectorAll(".toggle-pd-answer");
  const singleOptions = document.querySelectorAll(".single-option");
  const prescriptionInput = document.querySelector("#prescription_input");
  const doctorNameInput = document.querySelector('#doctors_name');
  const doctorPhoneInput = document.querySelector('#contact_number');
  const patientNameInput = document.querySelector('#patient_name');
  const dobMonthInput = document.querySelector('#patient_dob_month');
  const dobDateInput = document.querySelector('#patient_dob_date');
  const dobYearInput = document.querySelector('#patient_dob_year');
  const submitButtonSix = document.querySelector(".step-six .next-step");
  const allCheckoutBtns = document.querySelectorAll('[data-checkout]');
  const inputLabels = document.querySelectorAll('.opt-label');
  // PD step references (redesigned step-seven)
  const pdCards = document.querySelectorAll('.step-seven .rx-card[data-pd-option]');
  const pdCheckoutBtnSeven = document.querySelector('.step-seven [data-checkout]');
  const pdCheckoutBtnEight = document.querySelector('.step-eight [data-checkout]');
  const appPdInput = document.querySelector('#app_pd_value');
  let pdSelectedOption = null;
  let pdIsDual = false;
  // New: Initial card-based options for Step 1 popup
  const initialCards = document.querySelectorAll('.show-initial-options .initial-single-option.card');

  function resetSpecificFieldset(fieldsetId) {
    const fieldset = document.querySelector(fieldsetId);
    console.log(fieldset, 'Reset form');
    if (fieldset) {
        const inputs = fieldset.querySelectorAll('input, select, textarea');
        inputs.forEach(input => {
            switch (input.type) {
                case 'text':
                case 'password':
                case 'email':
                case 'number':
                case 'tel':
                case 'url':
                    input.value = input.defaultValue;
                    break;
                case 'checkbox':
                case 'radio':
                    input.checked = input.defaultChecked;
                    break;
                case 'select-one':
                case 'select-multiple':
                    Array.from(input.options).forEach(option => {
                        option.selected = option.defaultSelected;
                    });
                    break;
                case 'textarea':
                    input.value = input.defaultValue;
                    break;
            }
        });
    }
  }

  function getPreviousSiblings(element) {
    const siblings = [];
    let currentElement = element.previousElementSibling;
    while (currentElement) {
      siblings.unshift(currentElement);
      currentElement = currentElement.previousElementSibling;
    }
    return siblings;
  }

  function getAllNextSiblings(element) {
    const siblings = [];
    let currentSibling = element.nextElementSibling;
    while (currentSibling) {
      siblings.push(currentSibling);
      currentSibling = currentSibling.nextElementSibling;
    }
    return siblings;
  }

  function getStepClass(node) {
    if (!node || !node.classList) return null;
    for (const cls of node.classList) {
      if (cls.startsWith("step-")) {
        return cls;
      }
    }
    return null;
  }

  function updateTabsNav(currentTab, previousTab) {
    const newCurrentStep = document.querySelector("." + currentTab);
    let activeTab = newCurrentStep.dataset.step;
    let currentActiveTab = document.querySelector(
      `.nav-buttons ul li.${activeTab}`
    );
    currentActiveTab.classList.add("active-tab");
    const previousElements = getPreviousSiblings(currentActiveTab);
    const nextElements = getAllNextSiblings(currentActiveTab);
    previousElements.forEach(pEl => {
      if (!pEl.classList.contains("active-tab")) {
        pEl.classList.add("active-tab");
      }
    });

    nextElements.forEach(nEl => {
      if (nEl.classList.contains("active-tab")) {
        nEl.classList.remove("active-tab");
      }
    });

    prevEls.forEach(pElSel => {
      pElSel.dataset.currentTab = currentTab;
      pElSel.dataset.prevTab = previousTab;
    });
  }

  function updateSubTotal() {
    const allPrices = document.querySelectorAll(".selection-details .price");
    let subTotal = Customizer.formatMoney(
      Array.from(allPrices)
        .map(node => Math.round(parseFloat(node.textContent.replace(/[^0-9.-]/g, "")) || 0))
        .filter(val => !isNaN(val))
        .reduce((sum, val) => sum + val, 0) * 100
    );
    document.querySelector(".subtotal .total-price").textContent = subTotal;
    document.querySelector(".sub-total-mobile").textContent = subTotal;
    updateEmptyStates();
  }
  // Expose for customizer-lancier.js (engraving summary updates)
  window.updateSubTotal = updateSubTotal;

  function updateEmptyStates() {
    document.querySelectorAll('.summary-group').forEach(function(group) {
      var emptyEl = group.querySelector('.empty-state');
      if (!emptyEl) return;
      var hasContent = false;
      group.querySelectorAll('.line-item--pending').forEach(function(item) {
        var title = item.querySelector('h2.title');
        if (title && title.textContent.trim() !== '') {
          hasContent = true;
          item.classList.add('line-item--filled');
        } else {
          item.classList.remove('line-item--filled');
        }
      });
      emptyEl.style.display = hasContent ? 'none' : 'block';
    });
  }

  function validateInputs() {
    const doctorName = doctorNameInput.value.trim();
    const doctorPhone = doctorPhoneInput.value.trim();
    const patientName = patientNameInput.value.trim();
    const dobMonth = dobMonthInput.value.trim();
    const dobDate = dobDateInput.value.trim();
    const dobYear = dobYearInput.value.trim();

    let isValid =
      doctorName !== "" &&
      doctorPhone !== "" &&
      patientName !== "" &&
      dobMonth !== "" &&
      dobDate !== "" &&
      dobYear !== "";

    if (isValid) {
      const month = parseInt(dobMonth, 10);
      const date = parseInt(dobDate, 10);
      const year = parseInt(dobYear, 10);
      const currentYear = new Date().getFullYear();
      if (isNaN(month) || month < 1 || month > 12) {
        isValid = false;
        dobMonthInput.setCustomValidity("Enter correct DOB.");
        dobMonthInput.reportValidity();
      }
      if (isValid && (isNaN(date) || date < 1 || date > 31)) {
        isValid = false;
        dobDateInput.setCustomValidity("Enter correct DOB.");
        dobDateInput.reportValidity();
      }
      if (isValid && (isNaN(year) || year < 1900 || year > currentYear)) {
        isValid = false;
        dobYearInput.setCustomValidity("Enter correct DOB.");
        dobYearInput.reportValidity();
      }
    }
    if (isValid) {
      const phoneRegex = /^[0-9]{7,}$/;
      if (!phoneRegex.test(doctorPhone)) isValid = false;
      if (!isValid) {
        doctorPhoneInput.setCustomValidity(
          "Enter correct Phone number. (digits only, at least 7 digits)"
        );
        doctorPhoneInput.reportValidity();
      }
    }
    submitButtonSix.disabled = !isValid;
  }

  function isValidNumber(value) {
    return value.trim() !== "" && !isNaN(parseFloat(value));
  }

  // Validate PD input on step-seven "I know my PD" card
  function validatePdInput() {
    if (pdSelectedOption !== 'know') return;
    let valid = false;
    if (pdIsDual) {
      const r = document.getElementById('pd_right');
      const l = document.getElementById('pd_left');
      valid = r && l && isValidNumber(r.value) && isValidNumber(l.value);
    } else {
      const s = document.getElementById('pupillary_distance');
      valid = s && isValidNumber(s.value);
    }
    if (pdCheckoutBtnSeven) pdCheckoutBtnSeven.disabled = !valid;
  }
  // Make it globally accessible for inline oninput
  window.validatePdInput = validatePdInput;

  // Validate PD input on step-eight "Measure" page
  function validateMeasurePdInput() {
    if (appPdInput && pdCheckoutBtnEight) {
      pdCheckoutBtnEight.disabled = !isValidNumber(appPdInput.value);
    }
  }
  window.validateMeasurePdInput = validateMeasurePdInput;

  // Toggle dual PD fields
  function toggleDualPd() {
    pdIsDual = !pdIsDual;
    const track = document.getElementById('pdDualToggle');
    const fields = document.getElementById('pdFields');
    if (pdIsDual) {
      track.classList.add('on');
      fields.innerHTML =
        '<div class="pd-field"><label for="pd_right">Right Eye (mm)</label>' +
        '<input type="text" name="properties[Pupillary Distance - Right]" id="pd_right" placeholder="e.g. 31" maxlength="4" onclick="event.stopPropagation()" oninput="validatePdInput()"></div>' +
        '<div class="pd-field"><label for="pd_left">Left Eye (mm)</label>' +
        '<input type="text" name="properties[Pupillary Distance - Left]" id="pd_left" placeholder="e.g. 32" maxlength="4" onclick="event.stopPropagation()" oninput="validatePdInput()"></div>';
    } else {
      track.classList.remove('on');
      fields.innerHTML =
        '<div class="pd-field"><label for="pupillary_distance">Pupil Distance (mm)</label>' +
        '<input type="text" name="properties[Pupillary Distance]" id="pupillary_distance" placeholder="e.g. 63" maxlength="4" onclick="event.stopPropagation()" oninput="validatePdInput()"></div>';
    }
    validatePdInput();
  }
  window.toggleDualPd = toggleDualPd;

  // Toggle "What is PD?" info
  function togglePdInfo() {
    const toggle = document.querySelector('.pd-info-toggle');
    const content = document.getElementById('pdInfoContent');
    if (toggle) toggle.classList.toggle('open');
    if (content) content.classList.toggle('open');
  }
  window.togglePdInfo = togglePdInfo;

  // New: Generate QR code for EyeMeasure app download (desktop only)
  function initEyeMeasureQR() {
    const qrContainer = document.getElementById('eyemeasure-qr');
    if (!qrContainer) return;
    // Only generate on desktop
    if (window.innerWidth <= 850) return;
    // Check if QRCode library is loaded
    if (typeof QRCode === 'undefined') {
      // Load the library dynamically
      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js';
      script.onload = function() {
        generateQR(qrContainer);
      };
      document.head.appendChild(script);
    } else {
      generateQR(qrContainer);
    }
  }

  function generateQR(container) {
    if (!container || typeof QRCode === 'undefined') return;
    container.innerHTML = '';
    new QRCode(container, {
      text: 'https://apps.apple.com/us/app/eyemeasure/id1417435049',
      width: 84,
      height: 84,
      colorDark: '#1a1a1a',
      colorLight: '#ffffff',
      correctLevel: QRCode.CorrectLevel.M
    });
  }

  // New: Handle mobile detection for EyeMeasure section
  function updateMobileDesktopVisibility() {
    const isMobile = window.innerWidth <= 850;
    const desktopEls = document.querySelectorAll('.app-download-desktop');
    const mobileEls = document.querySelectorAll('.app-download-mobile');
    desktopEls.forEach(el => { el.style.display = isMobile ? 'none' : ''; });
    mobileEls.forEach(el => { el.style.display = isMobile ? 'inline-block' : 'none'; });
  }

  Customizer.money_format = theme.money_format;
  Customizer.formatMoney = function(cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;
    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split("."),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
        cents = parts[1] ? decimal + parts[1] : "";
      return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  };

  // ===== STEP 1: Initial popup card click handling =====
  // New card-based click handler for the elevated Step 1 popup
  if (initialCards.length > 0) {
    initialCards.forEach(card => {
      card.addEventListener('click', function(evt) {
        // Don't fire if clicking the radio input itself (it already handles via change event)
        if (evt.target.tagName === 'INPUT') return;

        // Remove selected from all cards
        initialCards.forEach(c => c.classList.remove('selected'));
        // Add selected to this card
        card.classList.add('selected');
        const ctaBtn = document.querySelector('.show-initial-options .cta-btn');
            if (ctaBtn) {
              ctaBtn.textContent = card.dataset.value === 'variant' ? 'Proceed to Checkout' : 'Continue';
            }

        // Check the hidden radio input inside this card
        const radio = card.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          // Trigger change event to enable the CTA button
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  initialButton.addEventListener("click", function() {
    initialWrapper.style.display = "block";
    let variantName = document.querySelector('.opposing-items span.label__value').textContent;
    let variantPrice = document.querySelector('.price-container .price-area .current-price').textContent;
    let variantImage = document.querySelector('.gallery .slick-active img.rimage__image').dataset.altsrc;
    let variantId = document.querySelectorAll('.shopify-product-form')[0].querySelector('input[name="id"]').value;
    document.querySelector('.modal-image-wrapper img.custom-class').src = 'https:' + variantImage;
    document.querySelector('.selection-details .variant-title').textContent = variantName;
    document.querySelector('.selection-details .price').textContent = variantPrice.replace('.00', '');
    document.querySelector('[data-open="customizer-modal"]').dataset.variant = variantId;
  });

  initialClose.addEventListener("click", function() {
    initialWrapper.style.display = "none";
  });

  document.addEventListener("click", e => {
    if (e.target == document.querySelector(".modal.is-visible")) {
      document.querySelector(".modal.is-visible").classList.remove(isVisible);
    }
  });

  document.addEventListener("keyup", e => {
    if (e.key == "Escape" && document.querySelector(".modal.is-visible")) {
      document.querySelector(".modal.is-visible").classList.remove(isVisible);
    }
  });

  for (const el of initalRadioGroup) {
    el.addEventListener("change", function() {
      const formButton = document.querySelector(".show-initial-options .cta-btn");
      if (!formButton) {
        // Fallback to old selector if cta-btn not found
        const fallbackBtn = document.querySelector(".show-initial-options .btn");
        if (fallbackBtn) fallbackBtn.disabled = false;
      } else {
        formButton.disabled = false;
      }
      resetSpecificFieldset('.variant-options');
    });
  }

  for (const el of openEls) {
    el.addEventListener("click", function() {
      // Save scroll position before locking body
      document.body.dataset.scrollY = window.scrollY;
      document.body.style.top = '-' + window.scrollY + 'px';
      document.body.classList.add('customizer-open');
      const idInput = document.querySelectorAll('[name="id"]')[0];
      const customForm = document.querySelector("#product-form-customisable");
      const checkedRadio = document.querySelector(
        "input[name='radio-group']:checked"
      );
      const input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.setAttribute("name", "id");
      input.setAttribute("value", idInput.value);
      customForm.appendChild(input);
      if (checkedRadio != null) {
        if (checkedRadio.value === "customize") {
          const modalId = this.dataset.open;
          document.getElementById(modalId).classList.add(isVisible);
          // Initialize QR code when modal opens (if EyeMeasure section exists)
          initEyeMeasureQR();
          updateMobileDesktopVisibility();

          // Reposition Tidio chat ONLY when the customizer modal actually opens
          const host = document.querySelector("#tidio-chat");
          if (host) {
            const shadow = host.shadowRoot;
            const chatRoot = shadow ? shadow.querySelector("#tidio-chat-root") : null;
            if (chatRoot) chatRoot.style.inset = "unset";

            /* Inject shadow DOM style to fix chat panel display at top-left */
            if (shadow) {
              var existingFix = shadow.getElementById("sc-tidio-fix");
              if (!existingFix) {
                var fixStyle = document.createElement("style");
                fixStyle.id = "sc-tidio-fix";
                fixStyle.textContent = ".chat { position: absolute !important; top: 68px !important; height: auto !important; max-height: calc(100vh - 100px) !important; min-height: 400px !important; }";
                shadow.appendChild(fixStyle);
              }

              const shadowBtn = shadow.querySelector('.mobile-size__large');
              if (shadowBtn && chatRoot) {
                shadowBtn.addEventListener('click', function(){
                  chatRoot.style.inset = "unset";
                });
              }
            }
          }
        }
        if (checkedRadio.value === "variant") {
          customForm.submit();
        }
      }
      updateSubTotal();
    });
  }

  for (const el of closeEls) {
    el.addEventListener("click", function() {
      // Restore scroll position after unlocking body
      var scrollY = parseInt(document.body.dataset.scrollY || '0', 10);
      document.body.classList.remove('customizer-open');
      document.body.style.top = '';
      window.scrollTo(0, scrollY);
      const modalId = this.dataset.close;
      document.getElementById(modalId).classList.remove(isVisible);

            const host = document.querySelector("#tidio-chat");
            if (host) {
              const shadow = host.shadowRoot;
              const chatRoot = shadow ? shadow.querySelector("#tidio-chat-root") : null;
              if (chatRoot) chatRoot.style.inset = "0px 0px 0px auto";

              /* Remove the shadow DOM fix style */
              if (shadow) {
                var existingFix = shadow.getElementById("sc-tidio-fix");
                if (existingFix) { existingFix.remove(); }

                const shadowBtn = shadow.querySelector('.mobile-size__large');
                if (shadowBtn && chatRoot) {
                  shadowBtn.addEventListener('click', function(){
                    chatRoot.style.inset = "0px 0px 0px auto";
                  });
                }
              }
            }
    });
  }

  /* === Transitions Color Filter by Lens Material === */
  function filterTransitionsColors() {
    var stepTwo = document.querySelector('.step-two');
    var stepFour = document.querySelector('.step-four');
    if (!stepTwo || !stepFour) return;

    var material = (stepTwo.dataset.selectedMaterial || '').trim();
    var isLancier = !!document.querySelector('.lancier-modal');
    var allColors = ['Grey', 'Brown', 'Sapphire', 'Graphite Green', 'Amethyst', 'Amber', 'Ruby', 'Emerald'];
    var allowedColors = allColors; // default: all

    // Determine allowed colors based on flow + material
    if (isLancier) {
      // Dita flow: only High Index 1.74 is restricted
      if (material === 'High Index 1.74') {
        allowedColors = ['Grey', 'Brown'];
      }
    } else {
      // Non-Dita flow
      if (material === 'Trivex') {
        allowedColors = ['Grey', 'Brown', 'Graphite Green'];
      } else if (material === 'High Index 1.74') {
        allowedColors = ['Grey', 'Brown'];
      }
    }

    // Show/hide color cards
    var colorCards = stepFour.querySelectorAll('.color-card');
    var visibleCount = 0;
    colorCards.forEach(function(card) {
      var title = (card.dataset.title || '').trim();
      if (allowedColors.indexOf(title) !== -1) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
        // If this hidden card was selected, deselect it
        if (card.classList.contains('selected')) {
          card.classList.remove('selected');
          stepFour.dataset.selectedVariantId = '';
          stepFour.dataset.title = '';
          stepFour.dataset.price = '';
          // Disable the Next button since selection was cleared
          var nextBtn = stepFour.querySelector('.next-step');
          if (nextBtn) nextBtn.disabled = true;
        }
      }
    });

    // Update the material note text
    var materialNote = stepFour.querySelector('.material-note');
    if (materialNote) {
      if (visibleCount < allColors.length) {
        materialNote.textContent = 'Showing ' + visibleCount + ' of ' + allColors.length + ' colors available for ' + material;
      } else {
        materialNote.textContent = 'Showing colors available for your selected lens material';
      }
    }

    console.log('[Customizer] Transitions filter:', material, '→', visibleCount, 'of', allColors.length, 'colors');
  }

  /* === Polarized Color Filter by Lens Material === */
  /* G15 is only available for Polycarbonate, High Index 1.67, and High Index 1.74.
     Hidden for all other materials (e.g. Trivex, MR-8 1.60). */
  function filterPolarizedColors() {
    var stepTwo = document.querySelector('.step-two');
    if (!stepTwo) return;

    var material = (stepTwo.dataset.selectedMaterial || '').trim();
    var g15Materials = ['Polycarbonate', 'High Index 1.67', 'High Index 1.74'];
    var showG15 = g15Materials.indexOf(material) !== -1;

    // There are multiple .step-four divs — find the one containing [data-polarized-lens]
    var polarizedContent = document.querySelector('[data-polarized-lens]');
    if (!polarizedContent) return;

    var stepFour = polarizedContent.closest('.step-four');
    var optionItems = polarizedContent.querySelectorAll('.option-item');
    optionItems.forEach(function(item) {
      var title = (item.dataset.title || '').toLowerCase();
      if (title.indexOf('g15') !== -1 || title.indexOf('g-15') !== -1) {
        if (showG15) {
          item.style.setProperty('display', 'flex', 'important');
        } else {
          item.style.setProperty('display', 'none', 'important');
          if (item.classList.contains('selected')) {
            item.classList.remove('selected');
            if (stepFour) {
              stepFour.dataset.selectedVariantId = '';
              stepFour.dataset.title = '';
              stepFour.dataset.price = '';
              var nextBtn = stepFour.querySelector('.next-step');
              if (nextBtn) nextBtn.disabled = true;
            }
          }
        }
      }
    });
  }

  for (const nEl of nextEls) {
    nEl.addEventListener("click", function(event) {
      const currentStep = event.target.closest(".steps");
      currentStep.classList.remove(isVisible);
      const classIdentifier = ".steps." + nEl.dataset.nextStep;
      document.querySelector(classIdentifier).classList.add(isVisible);
      updateTabsNav(nEl.dataset.nextStep, getStepClass(currentStep));

      // Filter Transitions and Polarized colors when entering step-four
      if (nEl.dataset.nextStep === 'step-four') {
        filterTransitionsColors();
        filterPolarizedColors();
      }
      if (currentStep.dataset.step === "step-tab-four") {
        if (currentStep.dataset.type == 'Transitions') {
          document.querySelector(
            'input[name="properties[Transitions Lens]"'
          ).value =
            currentStep.dataset.title;
          document.querySelector(
            'input[name="properties[_transitionsLensVariantId]"'
          ).value =
            currentStep.dataset.selectedVariantId; /* SPECS FIX 10AUG2026: was dataset.variantId (never set) -> wrote literal "undefined" */
          document.querySelector(
            'input[name="properties[_transitionsLensVariantPrice]"'
          ).value =
            currentStep.dataset.price;
          document.querySelector(
              ".addon-product .info-row[data-transition] h2.title"
            ).innerHTML =
              'Transitions - ' + currentStep.dataset.title;
          document.querySelector(
              ".addon-product .info-row[data-transition] h5.price"
            ).innerHTML =
              currentStep.dataset.price;
        } else if (currentStep.dataset.type == 'Tinted') {
          var selectedTintColor = currentStep.dataset.title;
          if (selectedTintColor === 'Tinted Lens Options - Other') {
            selectedTintColor = selectedTintColor + ' (' + document.querySelector('#custom_tint_text').value + ')';
          }
          document.querySelector(
            'input[name="properties[Tinted Color Option]"'
          ).value =
            selectedTintColor;
          document.querySelector(
            'input[name="properties[_tintedColorVariantId]"'
          ).value =
            currentStep.dataset.selectedVariantId;
          document.querySelector(
            'input[name="properties[_tintedColorVariantPrice]"'
          ).value =
            currentStep.dataset.price;
          // Update sidebar summary row (generic addon row; not the [data-transition] one)
          var tintedDisplayLabel = currentStep.dataset.title;
          if (tintedDisplayLabel === 'Tinted Lens Options - Other') {
            tintedDisplayLabel = 'Custom (' + document.querySelector('#custom_tint_text').value + ')';
          }
          var tintedAddonRow = document.querySelector(".addon-product .info-row:not([data-transition])");
          if (tintedAddonRow) {
            tintedAddonRow.classList.remove("is-hidden");
            var tintedAddonTitle = tintedAddonRow.querySelector("h2.title");
            var tintedAddonPrice = tintedAddonRow.querySelector("h5.price");
            if (tintedAddonTitle) tintedAddonTitle.innerHTML = 'Tinted - ' + tintedDisplayLabel;
            if (tintedAddonPrice) tintedAddonPrice.innerHTML = currentStep.dataset.price;
          }
          // Hide the transition row in case the user previously selected Transitions
          var tintedTransitionRow = document.querySelector(".addon-product .info-row[data-transition]");
          if (tintedTransitionRow) {
            var tintedTransitionTitle = tintedTransitionRow.querySelector("h2.title");
            var tintedTransitionPrice = tintedTransitionRow.querySelector("h5.price");
            if (tintedTransitionTitle) tintedTransitionTitle.innerHTML = '';
            if (tintedTransitionPrice) tintedTransitionPrice.innerHTML = '';
          }
        } else if (currentStep.dataset.type == 'Polarized') {
          document.querySelector(
            'input[name="properties[Polarized Color Option]"'
          ).value =
            currentStep.dataset.title;
          document.querySelector(
            'input[name="properties[_polarizedColorVariantId]"'
          ).value =
            currentStep.dataset.selectedVariantId;
          document.querySelector(
            'input[name="properties[_polarizedColorVariantPrice]"'
          ).value =
            currentStep.dataset.price;
          // Update sidebar summary row (generic addon row; not the [data-transition] one)
          var polarizedAddonRow = document.querySelector(".addon-product .info-row:not([data-transition])");
          if (polarizedAddonRow) {
            polarizedAddonRow.classList.remove("is-hidden");
            var polarizedAddonTitle = polarizedAddonRow.querySelector("h2.title");
            var polarizedAddonPrice = polarizedAddonRow.querySelector("h5.price");
            if (polarizedAddonTitle) polarizedAddonTitle.innerHTML = 'Polarized - ' + currentStep.dataset.title;
            if (polarizedAddonPrice) polarizedAddonPrice.innerHTML = currentStep.dataset.price;
          }
          // Hide the transition row in case the user previously selected Transitions
          var polarizedTransitionRow = document.querySelector(".addon-product .info-row[data-transition]");
          if (polarizedTransitionRow) {
            var polarizedTransitionTitle = polarizedTransitionRow.querySelector("h2.title");
            var polarizedTransitionPrice = polarizedTransitionRow.querySelector("h5.price");
            if (polarizedTransitionTitle) polarizedTransitionTitle.innerHTML = '';
            if (polarizedTransitionPrice) polarizedTransitionPrice.innerHTML = '';
          }
        }
      }

      /* Prescription data capture — file upload is now in step-five, doctor form in step-six */
      if (currentStep.dataset.step === "step-tab-five" || currentStep.dataset.step === "step-tab-six") {
        const prescriptionFile = document.querySelector('#prescription_input');
        const selectedRxOption = document.querySelector('.rx-card.selected');
        const rxOption = selectedRxOption ? selectedRxOption.dataset.rxOption : null;

        if (rxOption === 'upload' && prescriptionFile && prescriptionFile.files.length !== 0) {
          document.querySelector('#lens_options_input_prescription_upload').files = prescriptionFile.files;
          document.querySelector('#lens_options_input_prescription_text').value = '';
        } else if (rxOption === 'later' || currentStep.dataset.step === "step-tab-five") {
          document.querySelector('#lens_options_input_prescription_upload').value = null;
          document.querySelector('#lens_options_input_prescription_text').value = 'Send it Later';
        }

        if (currentStep.dataset.step === "step-tab-six") {
          document.querySelector('#lens_options_input_prescription_upload').value = null;
          document.querySelector('#lens_options_input_prescription_text').value = `Doctor Name: ${doctorNameInput.value}, Doctor Phone: ${doctorPhoneInput.value}, Patient Name: ${patientNameInput.value}, Patient DOB: ${dobMonthInput.value}/${dobDateInput.value}/${dobYearInput.value}`;
        }
      }
      updateSubTotal();
    });
  }

  for (const pEl of prevEls) {
    pEl.addEventListener("click", function(event) {
      const newCurrentTab = document.querySelector("." + pEl.dataset.prevTab);
      document
        .querySelector("." + pEl.dataset.currentTab)
        .classList.remove(isVisible);
      newCurrentTab.classList.add(isVisible);
      let prevTab =
        getStepClass(newCurrentTab.previousElementSibling) != null
          ? getStepClass(newCurrentTab.previousElementSibling)
          : "";
      updateTabsNav(pEl.dataset.prevTab, prevTab);
    });
  }

  for (const cEl of colorOptions) {
    cEl.addEventListener("click", function(event) {
      const currentStep = cEl.closest(".steps");
      currentStep.querySelectorAll(".single-color").forEach(el => {
        el.classList.remove("selected");
      });
      cEl.classList.add("selected");
      currentStep.dataset.selectedVariantId = cEl.dataset.variantId;
      currentStep.dataset.price = cEl.dataset.price;
      currentStep.dataset.title = cEl.dataset.title;

      currentStep.querySelector(".next-step").disabled = false;
    });
  }

  for (const sEl of sunglassesOptions) {
    sEl.addEventListener("click", function(event) {
      const currentStep = sEl.closest(".steps");
      currentStep.querySelectorAll(".option-item").forEach(el => {
        el.classList.remove("selected");
      });
      sEl.classList.add("selected");
      currentStep.dataset.selectedVariantId = sEl.dataset.variantId;
      currentStep.dataset.price = sEl.dataset.price;
      currentStep.dataset.title = sEl.dataset.title;
      currentStep.querySelector(".next-step").disabled = false;
      // If this is the "Other" card with a text input, focus it
      // (but only if it's not already focused, to avoid keyboard flicker on mobile)
      var tintInput = sEl.querySelector('#custom_tint_text');
      if (tintInput && document.activeElement !== tintInput) {
        tintInput.focus();
      }
    });
  }

  // Auto-select the "Other" card when the custom tint input is interacted with.
  // Instead of calling .click() (which re-focuses the input in a loop),
  // directly select the card and update the step data.
  var customTintInput = document.querySelector('#custom_tint_text');
  if (customTintInput) {
    function selectOtherCard() {
      var otherCard = customTintInput.closest('.option-item');
      if (!otherCard) return;
      if (!otherCard.classList.contains('selected')) {
        var currentStep = otherCard.closest('.steps');
        if (currentStep) {
          // Deselect all other option-items in this step
          currentStep.querySelectorAll('.option-item').forEach(function(el) {
            el.classList.remove('selected');
          });
          // Select the Other card
          otherCard.classList.add('selected');
          // Update step data
          currentStep.dataset.selectedVariantId = otherCard.dataset.variantId;
          currentStep.dataset.price = otherCard.dataset.price;
          currentStep.dataset.title = otherCard.dataset.title;
          // Enable the Next button
          var nextBtn = currentStep.querySelector('.next-step');
          if (nextBtn) nextBtn.disabled = false;
        }
      }
    }

    // Select on focus (when user taps the text field)
    customTintInput.addEventListener('focus', selectOtherCard);

    // Also select on any input (typing), in case focus didn't fire cleanly
    customTintInput.addEventListener('input', selectOtherCard);

    // On mobile, keep the Other card visible when the keyboard opens
    customTintInput.addEventListener('focus', function() {
      var otherCard = customTintInput.closest('.option-item');
      if (otherCard) {
        setTimeout(function() {
          otherCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 400);
      }
    });
  }

  for (const so of singleOptions) {
    so.addEventListener("click", function(evt) {
      const currentOptions = evt.target.closest(".available-options");
      const currentOption = evt.target.closest(".single-option");
      const currentStep = evt.target.closest(".steps");

      if (currentStep.classList.contains("step-one")) {
        currentStep.dataset.selectedType = currentOption.dataset.type;
        currentStep.classList.remove("is-visible");
        currentStep.nextElementSibling.classList.add("is-visible");
        const stepTwo = document.querySelectorAll(".step-two .single-option");
        stepTwo.forEach(el => {
          const priceElement = el.querySelector("p.price");
          priceElement.innerHTML =
            priceElement.dataset[currentOption.dataset.type];
        });
        updateTabsNav("step-two", "step-one");
      }

      if (currentStep.classList.contains("step-two")) {
        const previousElement = currentStep.previousElementSibling;
        currentStep.dataset.selectedMaterial = currentOption.dataset.type;
        currentStep.classList.remove("is-visible");
        currentStep.nextElementSibling.classList.add("is-visible");
        const stepOne = document.querySelector(".step-one");
        document.querySelector(".step-two").dataset.selectedVariantId =
          currentOption.dataset[stepOne.dataset.selectedType];
        currentStep.dataset.price = currentOption.querySelector(".price").dataset[
          stepOne.dataset.selectedType
        ];
        document.querySelector(
          ".lens-product .info-row h2.title"
        ).innerHTML = `${previousElement.querySelector(
          `[data-type='${previousElement.dataset.selectedType}']`
        ).dataset.title} - ${currentStep.dataset.selectedMaterial} Lenses`;
        document.querySelector(".lens-product .info-row h5.price").innerHTML =
          currentStep.dataset.price;
        document.querySelector(
          'input[name="properties[Lens]"'
        ).value = `${previousElement.querySelector(
          `[data-type='${previousElement.dataset.selectedType}']`
        ).dataset.title} - ${currentStep.dataset.selectedMaterial} Lenses`;
        document.querySelector('input[name="properties[_lensVariantId]"').value =
          currentOption.dataset[stepOne.dataset.selectedType];
        document.querySelector(
          'input[name="properties[_lensVariantPrice]"'
        ).value =
          currentStep.dataset.price;
        updateTabsNav("step-three", "step-two");
        updateSubTotal();
      }

      if (currentStep.classList.contains("step-three")) {
                if (currentStep.dataset.allowMultiple !== undefined) {
          var isArOption = currentOption.hasAttribute('data-ar-option');
          var isTransitionOption = currentOption.hasAttribute('data-transition-lens');

          if (isArOption) {
            // Radio behavior: deselect other AR options first
            var wasSelected = currentOption.classList.contains('selected');
            currentStep.querySelectorAll('[data-ar-option]').forEach(function(opt) {
              if (opt !== currentOption) {
                opt.classList.remove('selected');
              }
            });
            // Toggle clicked option
            if (wasSelected) {
              currentOption.classList.remove('selected');
            } else {
              currentOption.classList.add('selected');
            }

            // Clear ALL AR form inputs first
            document.querySelector('input[name="properties[Blue Blocking Filter]"]').value = '';
            document.querySelector('input[name="properties[_blueBlockingFilterVariantId]"]').value = '';
            document.querySelector('input[name="properties[_blueBlockingFilterVariantPrice]"]').value = '';
            document.querySelector('input[name="properties[Premium Anti-Reflective]"]').value = '';
            document.querySelector('#lens_options_input_premium_ar_variant_id').value = '';
            document.querySelector('#lens_options_input_premium_ar_variant_price').value = '';

            // Update based on current selection state
            if (currentOption.classList.contains('selected')) {
              currentStep.dataset.selectedVariantId = currentOption.dataset.variantId;
              currentStep.dataset.price = currentOption.dataset.price;
              if (currentOption.hasAttribute('data-premium-ar')) {
                document.querySelector('input[name="properties[Premium Anti-Reflective]"]').value = currentOption.dataset.title;
                document.querySelector('#lens_options_input_premium_ar_variant_id').value = currentOption.dataset.variantId;
                document.querySelector('#lens_options_input_premium_ar_variant_price').value = currentOption.dataset.price;
              } else {
                document.querySelector('input[name="properties[Blue Blocking Filter]"]').value = currentOption.dataset.title;
                document.querySelector('input[name="properties[_blueBlockingFilterVariantId]"]').value = currentOption.dataset.variantId;
                document.querySelector('input[name="properties[_blueBlockingFilterVariantPrice]"]').value = currentOption.dataset.price;
              }
              document.querySelector(".addon-product .info-row").classList.remove('is-hidden');
              document.querySelector(".addon-product .info-row h2.title").innerHTML = currentOption.dataset.title;
              document.querySelector(".addon-product .info-row h5.price").innerHTML = currentOption.dataset.price;
            } else {
              currentStep.dataset.selectedVariantId = '';
              currentStep.dataset.price = '';
              document.querySelector(".addon-product .info-row").classList.add('is-hidden');
              document.querySelector(".addon-product .info-row h2.title").innerHTML = '';
              document.querySelector(".addon-product .info-row h5.price").innerHTML = '';
            }
          } else {
            // Transitions or other: simple toggle
            currentOption.classList.toggle("selected");
          }

          // Update CTA button based on selection state
          var colorOption = currentStep.querySelector("[data-transition-lens]");
          var arSelected = currentStep.querySelector("[data-ar-option].selected");
          var transitionsSelected = colorOption && colorOption.classList.contains("selected");
          var nextButton = currentStep.querySelector(".next-step");

          if (transitionsSelected) {
            // Transitions selected (with or without AR)
            nextButton.innerHTML = "NEXT: SELECT LENS COLOR";
            nextButton.dataset.nextStep = "step-four";
            nextButton.classList.remove("addons-ghost");
          } else if (arSelected) {
            // Only AR coating selected
            nextButton.innerHTML = "NEXT: PRESCRIPTION INFORMATION";
            nextButton.dataset.nextStep = "step-five";
            nextButton.classList.remove("addons-ghost");
            // Clear transitions form values
            document.querySelector('input[name="properties[Transitions Lens]"]').value = '';
            document.querySelector('input[name="properties[_transitionsLensVariantId]"]').value = '';
            document.querySelector('input[name="properties[_transitionsLensVariantPrice]"]').value = '';
            var transTitle = document.querySelector(".addon-product .info-row[data-transition] h2.title");
            if (transTitle) transTitle.innerHTML = '';
            var transPrice = document.querySelector(".addon-product .info-row[data-transition] h5.price");
            if (transPrice) transPrice.innerHTML = '';
          } else {
            // Nothing selected
            nextButton.innerHTML = "CONTINUE WITHOUT ADD-ONS";
            nextButton.dataset.nextStep = "step-five";
            nextButton.classList.add("addons-ghost");
            // Clear transitions form values
            document.querySelector('input[name="properties[Transitions Lens]"]').value = '';
            document.querySelector('input[name="properties[_transitionsLensVariantId]"]').value = '';
            document.querySelector('input[name="properties[_transitionsLensVariantPrice]"]').value = '';
            var transTitle = document.querySelector(".addon-product .info-row[data-transition] h2.title");
            if (transTitle) transTitle.innerHTML = '';
            var transPrice = document.querySelector(".addon-product .info-row[data-transition] h5.price");
            if (transPrice) transPrice.innerHTML = '';
          }
        } else {
          currentStep.classList.remove("is-visible");
          currentStep.nextElementSibling.classList.add("is-visible");
          document.querySelectorAll(".step-four .step-content").forEach(el => {
            el.style.display = "none";
          });
          document.querySelector(`.step-four`).dataset.type = currentOption.dataset.option == 'data-tinted-lens' ? 'Tinted' : 'Polarized';
          document.querySelector(
            `.step-four .step-content[${currentOption.dataset.option}]`
          ).style.display =
            "block";
          updateTabsNav("step-four", "step-three");
          // Filter polarized colors based on selected material
          if (currentOption.dataset.option === 'data-polarized-lens') {
            filterPolarizedColors();
          }
        }
        updateSubTotal();
      }

      /* Step-five now handled by rx-card click listeners below */

      /* Step-seven now handled by PD card click listeners below */
    });
  }

  inputLabels.forEach(label => {
    label.addEventListener('click', (event) => {
      const selectedValue = event.target.previousElementSibling;
      if (!selectedValue) return;
      const isAvailable = selectedValue.classList.contains('is-unavailable');
      if (!isAvailable) {
        initialButton.disabled = false;
        initialButton.textContent = 'ADD TO CART';
      } else {
        initialButton.disabled = true;
        initialButton.textContent = 'SOLD OUT';
      }
    });
  });

  prescriptionInput.addEventListener("change", function(event) {
    const fileInput = event.target;
    const rxCard = fileInput.closest('.rx-card');
    const fileNameSpan = rxCard.querySelector("span.file-name");
    const selectedFileEl = rxCard.querySelector(".selected-file");
    if (fileInput.files && fileInput.files.length > 0) {
      fileNameSpan.textContent = fileInput.files[0].name;
      selectedFileEl.classList.add("is-visible");
      // Hide the upload zone, show file confirmation
      rxCard.querySelector('.upload-zone').style.display = 'none';
    } else {
      fileNameSpan.textContent = "";
      selectedFileEl.classList.remove("is-visible");
      rxCard.querySelector('.upload-zone').style.display = '';
    }
  });

  // Note: PD photo upload (pdInput / #pd_test_image) has been replaced by EyeMeasure app flow.
  // The app_pd_value input feeds directly into the PD form field on checkout.

  [
    doctorNameInput,
    doctorPhoneInput,
    patientNameInput,
    dobMonthInput,
    dobDateInput,
    dobYearInput
  ].forEach(function(input) {
    input.addEventListener("blur", validateInputs);
  });

  /* ===== NEW: Rx-card click handlers for step-five inline expand ===== */
  const rxCards = document.querySelectorAll('.step-five .rx-card');
  const stepFiveCTA = document.querySelector('.step-five .step-footer .next-step');

  rxCards.forEach(function(card) {
    card.addEventListener('click', function(e) {
      const option = card.dataset.rxOption;

      // "Call my doctor" card navigates to step-six
      if (option === 'doctor') {
        document.querySelector('.step-five').classList.remove(isVisible);
        document.querySelector('.step-six').classList.add(isVisible);
        updateTabsNav('step-six', 'step-five');
        return;
      }

      // Deselect all cards
      rxCards.forEach(function(c) { c.classList.remove('selected'); });

      // Select this card (triggers CSS expand animation)
      card.classList.add('selected');

      // Enable the CTA button
      if (stepFiveCTA) {
        stepFiveCTA.disabled = false;
      }

      // Set prescription text for "send later"
      if (option === 'later') {
        document.querySelector('#lens_options_input_prescription_text').value = 'Send it Later';
      }
    });
  });

  /* Upload zone click triggers file input */
  const uploadZone = document.querySelector('.step-five .upload-zone');
  if (uploadZone) {
    uploadZone.addEventListener('click', function(e) {
      if (e.target.tagName !== 'INPUT') {
        const fileInput = uploadZone.querySelector('.upload-zone-file-input');
        if (fileInput) fileInput.click();
      }
    });
  }

  /* ===== PD card click handlers (step-seven redesign) ===== */
  pdCards.forEach(card => {
    card.addEventListener('click', function() {
      const option = card.dataset.pdOption;

      // "Help me measure it" — navigate to step-eight
      if (option === 'measure') {
        document.querySelector('.step-seven').classList.remove(isVisible);
        document.querySelector('.step-eight').classList.add(isVisible);
        updateTabsNav('step-eight', 'step-seven');
        initEyeMeasureQR();
        updateMobileDesktopVisibility();
        return;
      }

      // Deselect all cards, select this one
      pdCards.forEach(c => c.classList.remove('selected'));
      card.classList.add('selected');
      pdSelectedOption = option;

      if (option === 'later') {
        document.querySelector('#lens_options_input_pd_text').value = 'Send it Later';
        if (pdCheckoutBtnSeven) pdCheckoutBtnSeven.disabled = false;
      } else if (option === 'know') {
        document.querySelector('#lens_options_input_pd_text').value = '';
        validatePdInput();
      }
    });
  });

  // Validate app PD input for EyeMeasure flow (step-eight)
  if (appPdInput) {
    appPdInput.addEventListener('input', validateMeasurePdInput);
  }

  allCheckoutBtns.forEach((element) => {
    element.addEventListener("click", function (evt) {
      const currentStep = element.closest(".steps");

      // Step-seven: "I know my PD" or "Send it later"
      if (currentStep.classList.contains("step-seven")) {
        document.querySelector('#lens_options_input_pd_upload').value = null;
        if (pdSelectedOption === 'know') {
          if (pdIsDual) {
            const r = document.getElementById('pd_right');
            const l = document.getElementById('pd_left');
            if (r && l) {
              document.querySelector('#lens_options_input_pd_text').value = 'Left: ' + l.value + ', Right: ' + r.value;
            }
          } else {
            const s = document.getElementById('pupillary_distance');
            if (s) {
              document.querySelector('#lens_options_input_pd_text').value = s.value;
            }
          }
        }
        // "later" already set the value when the card was clicked
      }

      // Step-eight: "Measure with EyeMeasure"
      if (currentStep.classList.contains("step-eight")) {
        document.querySelector('#lens_options_input_pd_upload').value = null;
        if (appPdInput && appPdInput.value.trim() !== '') {
          document.querySelector('#lens_options_input_pd_text').value = appPdInput.value.trim();
        }
      }
      let mainVariantId = document.querySelector('[data-open="customizer-modal"]').dataset.variant;
      const fieldsetOptions = document.querySelector('fieldset.variant-options');
      fieldsetOptions.querySelector('input[name="id"]').value = mainVariantId;
      const stepTwo = document.querySelector('.step-two');
      const stepThree = document.querySelector('.step-three');
      const stepFour = document.querySelector('.step-four');
      let selectedVariantIds = [];
      let selectedVariantPrices = [];
      if (stepTwo.dataset.selectedVariantId != '') {
        selectedVariantIds.push(stepTwo.dataset.selectedVariantId);
      }
      if (stepTwo.dataset.price != '') {
        selectedVariantPrices.push(stepTwo.dataset.price);
      }
      // Skip stepThree variant if a sun card is selected (sun lens is added separately below
      // to avoid pushing the same variant ID twice — selectSunLens sets stepThree.dataset too)
      var hasSunCardSelected = !!document.querySelector('.sun-card.selected');
      if (!hasSunCardSelected && typeof stepThree.dataset.selectedVariantId !== "undefined" && stepThree.dataset.selectedVariantId != '') {
        selectedVariantIds.push(stepThree.dataset.selectedVariantId);
      }
      if (!hasSunCardSelected && typeof stepThree.dataset.price !== "undefined" && stepThree.dataset.price != '') {
        selectedVariantPrices.push(stepThree.dataset.price);
      }
      if (stepFour.dataset.selectedVariantId != '') {
        selectedVariantIds.push(stepFour.dataset.selectedVariantId);
      }
      if (stepFour.dataset.price != '') {
        selectedVariantPrices.push(stepFour.dataset.price);
      }

      // === Lancier: Engraving add-on ===
      // Uses the same pattern as tint/polarized: push variant ID into selectedVariantIds
      var engravingCard = document.getElementById('engraving-card');
      if (engravingCard && engravingCard.classList.contains('selected')) {
        var engVariantId = engravingCard.dataset.engravingVariantId
          || (window.lancierVariantIds && window.lancierVariantIds.engraving)
          || '';
        if (engVariantId && engVariantId !== '') {
          selectedVariantIds.push(engVariantId);
          // Engraving price for subtotal display
          var engPrice = engravingCard.dataset.engravingPrice || '$50';
          selectedVariantPrices.push(engPrice);
          console.log('[Customizer] Engraving variant added:', engVariantId);
        }
        // Write engraving text to the BASE form so it shows on the frame in cart
        // Property name is "Custom Laser Engraving", value is just the typed text
        var engInput = document.getElementById('engrave-input');
        var engText = engInput ? engInput.value.trim() : '';
        var engFormField = document.getElementById('lens_options_input_engraving_text');
        if (engFormField) {
          engFormField.value = engText ? 'Engraving Text: ' + engText : 'Yes';
          console.log('[Customizer] Engraving text set on base form:', engFormField.value);
        }
      }

      // === Lancier: Sun Lens add-on ===
      // Uses the same pattern as tint/polarized: push variant ID into selectedVariantIds
      var selectedSunCard = document.querySelector('.sun-card.selected');
      if (selectedSunCard) {
        var sunVariantId = selectedSunCard.dataset.variantId || '';
        if (sunVariantId && sunVariantId !== '') {
          selectedVariantIds.push(sunVariantId);
          var sunPrice = selectedSunCard.dataset.price || '';
          if (sunPrice) selectedVariantPrices.push(sunPrice);
          console.log('[Customizer] Sun lens variant added:', sunVariantId, selectedSunCard.dataset.title);
        }
        // Write sun lens name to the BASE form so it shows on the frame in cart
        var sunTitle = selectedSunCard.dataset.title || '';
        var sunFormField = document.getElementById('lens_options_input_sun_lens');
        if (sunFormField) {
          sunFormField.value = 'DITA Lancier ' + sunTitle + ' Lens';
          console.log('[Customizer] Sun lens set on base form:', sunFormField.value);
        }
      }

      document.querySelector('#lens_options_input_variant_ids').value = selectedVariantIds.join();
      document.querySelector('#lens_options_input_total_variant_price').value = selectedVariantPrices.map(str => parseFloat(str.replace(/[^0-9.-]/g, ''))).reduce((sum, num) => sum + num, 0) * 100;

      let productsToAdd = {'items': []};

      selectedVariantIds.forEach((variant) => {
        let newObject = { 'id': parseInt(variant), 'quantity': 1, 'properties': { '_parentProduct': mainVariantId } };
        productsToAdd['items'].push(newObject);
      });

      console.log('[Customizer] Final cart payload:', JSON.stringify(productsToAdd));

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(productsToAdd)
      })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(errData) {
            console.error('[Customizer] Cart add failed:', response.status, JSON.stringify(errData));
          });
        }
        return response.json().then(function(data) {
          console.log('[Customizer] Cart add success:', JSON.stringify(data));
        });
      })
      .then(function() {
        fieldsetOptions.querySelector('.lens_options_hide').click();
      })
      .catch(function(error) {
        console.error('[Customizer] Error adding products to cart:', error);
        fieldsetOptions.querySelector('.lens_options_hide').click();
      });
    });
  });

  // Listen for window resize to update mobile/desktop visibility
  window.addEventListener('resize', updateMobileDesktopVisibility);
});

/* ============================================
   STEP 3: Lens Material — Collapsible Details Toggle
   ============================================ */
function toggleLensDetails(e, btn) {
  e.stopPropagation();
  var details = btn.nextElementSibling;
  if (!details) {
    // If information is a text node or sibling, find the UL
    var parent = btn.closest('.option-details');
    if (parent) details = parent.querySelector('ul');
  }
  if (details) {
    details.classList.toggle('show');
    btn.classList.toggle('open');
    var isOpen = details.classList.contains('show');
    // Update button text while preserving the SVG
    var svg = btn.querySelector('svg');
    btn.textContent = isOpen ? 'Hide ' : 'Details ';
    if (svg) btn.appendChild(svg);
  }
}


/* ============================================
   Hide global nav-buttons when inline step indicator is present
   ============================================ */
(function() {
  function updateNavVisibility() {
    var visibleStep = document.querySelector('.steps.is-visible');
    var navButtons = document.querySelector('.nav-buttons');
    if (!navButtons) return;
    if (visibleStep && visibleStep.querySelector('.inline-step-indicator')) {
      navButtons.classList.add('hidden-for-step');
    } else {
      navButtons.classList.remove('hidden-for-step');
    }
  }
  updateNavVisibility();
  var observer = new MutationObserver(function() { updateNavVisibility(); });
  var modalQ = document.querySelector('.modal-questions');
  if (modalQ) {
    observer.observe(modalQ, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  /* ===== Skip/Remove upgrades toggle for step-three ===== */
  (function initSkipRemoveToggle() {
    function updateSkipLink() {
      var stepThree = document.querySelector(".step-three");
      if (!stepThree) return;
      var skipLink = stepThree.querySelector(".skip-link");
      if (!skipLink) return;
      var selected = stepThree.querySelectorAll(".single-option.selected");
      if (selected.length > 0) {
        skipLink.textContent = "Remove upgrades";
      } else {
        skipLink.textContent = "Skip upgrades";
      }
    }

    document.addEventListener("click", function(e) {
      var stepThree = document.querySelector(".step-three");
      if (!stepThree) return;
      var skipLink = stepThree.querySelector(".skip-link");
      if (!skipLink) return;

      /* If user clicked the skip/remove link */
      if (e.target === skipLink || e.target.closest(".skip-link")) {
        var selected = stepThree.querySelectorAll(".single-option.selected");
        if (selected.length > 0) {
          e.preventDefault();
          e.stopPropagation();
          selected.forEach(function(opt) {
            opt.classList.remove("selected");
            opt.setAttribute("data-selected-variant-id", "");
          });
          stepThree.setAttribute("data-selected-variant-id", "");
          stepThree.setAttribute("data-price", "");
          updateSkipLink();
          return;
        }
      }

      /* If user clicked a single-option in step-three, update skip link after a tick */
      if (e.target.closest(".step-three .single-option")) {
        setTimeout(updateSkipLink, 50);
      }
    });

    /* Also observe for class changes via MutationObserver */
    var observer = new MutationObserver(function() { updateSkipLink(); });
    var watchTarget = document.querySelector(".step-three .available-options");
    if (watchTarget) {
      observer.observe(watchTarget, { attributes: true, subtree: true, attributeFilter: ["class"] });
    }
  })();

/* ===== Transitions color selection for step-four ===== */
(function initTransitionsColorPage() {
  /* Fix DOM nesting: ensure step-four is a sibling of step-three, not a child */
  function fixStepFourNesting() {
    var stepFour = document.querySelector('.step-four');
    var stepThree = document.querySelector('.step-three');
    if (stepFour && stepThree && stepThree.contains(stepFour)) {
      stepThree.parentNode.insertBefore(stepFour, stepThree.nextSibling);
    }
  }
  fixStepFourNesting();

  /* Color selection handler */
  document.addEventListener('click', function(e) {
    var card = e.target.closest('.step-four .color-card');
    if (!card) return;

    var stepFour = card.closest('.step-four');
    if (!stepFour) return;

    /* Deselect previous */
    stepFour.querySelectorAll('.color-card.selected').forEach(function(c) {
      c.classList.remove('selected');
    });

    /* Select clicked card */
    card.classList.add('selected');

    /* Update step-four data attributes */
    stepFour.setAttribute('data-selected-variant-id', card.getAttribute('data-variant-id') || '');
    stepFour.setAttribute('data-price', card.getAttribute('data-price') || '');
    stepFour.setAttribute('data-title', card.getAttribute('data-title') || '');

    /* Enable CTA button */
    var nextBtn = stepFour.querySelector('.next-step');
    if (nextBtn) {
      nextBtn.disabled = false;
    }
  });
})();

})();
